import { render, staticRenderFns } from "./BoskTabNavigation.vue?vue&type=template&id=dfe22ed0&scoped=true&"
import script from "./BoskTabNavigation.vue?vue&type=script&lang=js&"
export * from "./BoskTabNavigation.vue?vue&type=script&lang=js&"
import style0 from "./BoskTabNavigation.vue?vue&type=style&index=0&id=dfe22ed0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe22ed0",
  null
  
)

export default component.exports